import { NextSeo } from 'next-seo';

//screens
import { TenderFailures } from '@/screens/Agents/TenderFailures';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function TenderFailuresPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        canonical="https://loadsmart.com/ai/tender-failures/"
        title="Tender Failures Agent | Loadsmart AI"
        description="When a carrier rejects a tender or lets it time out, the agent re-tenders down your routing guide and re-books the next eligible carrier inside a cost ceiling."
        openGraph={{
          url: 'https://loadsmart.com/ai/tender-failures/',
        }}
      />
      <JsonLd data={Organization} />
      <TenderFailures />
    </>
  );
}
